<template>
	<div id='notice' :class="[theme, padding === 'zero' ? 'no-padding' : '']">
		<h2 class="content_title">{{ totalInfo.title }}</h2>
		<div class="content_time" style="font-family: '思源 Regular';">{{ totalInfo.time | parseTime }}</div>
		<div class="content" v-html="content"></div>
		<div class="text-right">{{ $t('common.xp_team') }}</div>
		<div class="text-right">{{ totalInfo.time | parseTime('{y}-{m}-{d}') }}</div>
		<!-- <jgz-loading :loading-show='showLoading'></jgz-loading> -->
	</div>
</template>

<script>
	const htmlTxt = "<p>康康这个是什么一个情况咯？</p><p>我也不知道这玩意怎么破咯</p><p>假如发个公告又咋样。</p><p><br></p>"
	// import JgzLoading from '@/components/JgzLoading.vue'
	import {
		common
	} from '../../language/en'
	export default {
		name: 'Notice-XP',
		components: {
			// JgzLoading,
		},
		data() {
			return {
				noticeId: null,
				totalInfo: {},
				content: '',
				theme: 'day',
				padding: '',
				showLoading: false
			}
		},
		mounted() {
			this.theme = this.$route.query.theme
			this.noticeId = this.$route.query.noticeId;
			document.title = 'XP Notice';
			console.log(232, this.$route.query)
			// this.activeId = 27
			this.showLoading = true;
			this.getNotice()
			this.getInfo()
		},
		watch: {
			$route: {
				handler(newVal) {
					location.reload();
				},
				deep: true
			}
		},
		methods: {
			getInfo() {
				this.$MyAxios.get(`/api/news/${this.noticeId}/infos`, {}, response => {
					if (response.code == 1) {
						this.totalInfo = response.data
					}
				})
			},

			getNotice() {
				// let type = this.newsType;
				this.$MyAxios.getText(`/api/news/${this.noticeId}/content`, {},
					response => {
						this.showLoading = false
						if (response) {
							let regex = new RegExp('<img', 'g')
							let result = response.match(regex)
							let count = !result ? 0 : result.length
							if (count === 1) {
								this.padding = 'zero'
							} else {
								this.padding = ''
							}
							this.content = response
						} else {
							this.content = `<h1 style="text-align: center;">${this.$t('activity.failed')}</h1>`
						}

					},
					error => {
						this.showLoading = false
						console.error(error)
						this.content = `<h1 style="text-align: center;">${this.$t('activity.failed')}</h1>`
					}
				)
			},
		}
	}
</script>

<style lang='less'>
	#notice {
		min-height: 100vh;
		background: white;
		text-align: left;
		padding: 1.25rem 1.5625rem;

		&.no-padding {
			// padding: 0;
		}

		* {
			box-sizing: border-box;
		}

		overflow: hidden;
		position: relative;

		&.night {
			background: #181820;
		}

		h2 {
			font-size: 1.1875rem;
			color: #4B4D59;
			font-weight: bold;
			line-height: 1.5;
		}

		.content_title {
			font-size: 48px;
			margin-bottom: 30px;
		}

		.content_time {
			font-size: 28px;
			margin-bottom: 30px;
			color: #9D9DA6;
		}

		h1 {
			line-height: 1.5;
		}

		&.night h2 {
			color: #E3E3E1;
		}

		&.night span {
			color: #9D9DA6;
		}



		font-family: PingFang SC,
		Lantinghei SC,
		Helvetica Neue,
		Helvetica,
		Arial,
		Microsoft YaHei,
		\\\5FAE\8F6F\96C5\9ED1,
		STHeitiSC-Light,
		simsun,
		\\\5B8B\4F53,
		WenQuanYi Zen Hei,
		WenQuanYi Micro Hei,
		sans-serif;

		p {
			font-size: 1rem;
			color: #29293b;
			line-height: 2rem;
			text-align: justify
		}

		&.night p {
			color: #E3E3E1;
			background: #181820;
		}

		a {
			font-size: 1rem;
		}

		strong {
			font-size: 1.2rem;
			margin-top: 1.5rem;
			display: block;
		}

		&.night h1,
		&.night h2,
		&.night h3,
		&.night h4,
		&.night h5,
		&.night h6,
		&.night li {
			color: #E3E3E1;
			background: #181820;
		}

		ul li {
			overflow: hidden;
			display: -ms-flexbox;
			-webkit-line-clamp: 2
		}

		li {
			line-height: 1.8rem;
		}

		ul {
			margin-bottom: 1.5rem;
		}

		.content {
			margin-bottom: 40px;

			img {
				max-width: 100%;
			}
		}

		.text-right {
			text-align: right;
			margin-bottom: 20px;
		}

		&.night .text-right {
			color: #E3E3E1
		}
	}
</style>